module.exports = __webpack_public_path__ + "img/step3.00f4496e.png";